export function getGroupId() {
  return sessionStorage.getItem('groupId') || 'null';
}
export function getGroupIdDefault() {
  return sessionStorage.getItem('groupIdDefault') || 'null';
}
export function getGroupIdFromFc() {
  return sessionStorage.getItem('group_id_from_fc') || 'null';
}
